import { useContext } from 'react';
import ExternalFilesContext from './ExternalFilesContext';
import AddFiles from './AddFiles';
import sortByCreatedAt from '@/lib/utils/sorting/sortByCreatedAt';
import ExternalFile from './ExternalFile';
import type {
  DatabaseExternalFile,
  UploadedImage as UploadedImageType,
} from '@/lib/types';
import UploadedImagesContext from './UploadedImagesContext';
import UploadedImage from './UploadedImage';
import FilesWrapper from './FilesWrapper';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';

const FileAttachments = () => {
  const { images } = useContext(UploadedImagesContext);
  const { externalFiles } = useContext(ExternalFilesContext);

  const files = [...images, ...externalFiles];

  return (
    <FilesWrapper>
      {files
        .sort(sortByCreatedAt)
        .map((file: UploadedImageType | DatabaseExternalFile) => {
          if ('file' in file) {
            return (
              <UploadedImage image={file} key={`uploaded-image-${file.id}`} />
            );
          }

          return (
            <ExternalFile
              externalFile={file}
              key={`external-file-${file.id}`}
            />
          );
        })}
      <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
        <AddFiles />
      </RestrictedToPortfolioMode>
    </FilesWrapper>
  );
};

export default FileAttachments;
